import React from 'react';
import Projects from '../components/Projects';

export default function ProjectsPage() {
  return (
    <div className="pt-24 min-h-screen">
      <div className="container mx-auto px-4">
        <Projects />
      </div>
    </div>
  );
}
